import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import Style from '../../../../styles/common';

const Container = styled('div')`
  align-items: center;
  background-color: ${props => props.isActive && Style.color.ACTIVE_MANAGE_EVENT_BACKGROUND};
  border-bottom: ${props => (!props.isLast || (props.isLast && props.isActive)) && '2px solid' + Style.color.listDivider};
  border-left: ${props => props.isActive && '6px solid' + Style.color.ACTIVE_MANAGE_EVENT_BORDER};
  cursor: pointer;
  display: flex;
  opacity: ${props => !props.isActive && 0.75};
  padding: 4rem;
  position: relative;
  transition: 0.1s all;
  
  &:hover {
    background-color: ${props => !props.isActive && Style.color.HOVER_MANAGE_EVENT_BACKGROUND};
    opacity: ${props => !props.isActive && 1};
  }
`;

// Hack to cover sidebar border for active item
const Cover = styled('div')`
  background-color: ${Style.color.ACTIVE_MANAGE_EVENT_BACKGROUND};
  height: 100%;
  position: absolute;
  top: 0;
  right: -2px;
  width: 2px;
`;

const Image = styled('img')`
  max-height: 75px;
  max-width: 60px;
  margin-right: 1rem;
`;

const Title = styled('h1')`
  font-size: 1rem;
  font-weight: ${Style.FONT_WEIGHT.MEDIUM};
`;

function ManageEventsSidebarItem(props) {
  const cover = props.isActive ? <Cover /> : null;
  return (
    <Container
      isActive={props.isActive}
      isLast={props.isLast}
      onClick={onClick}
    >
      <Image src={props.posterUrl} />
      <Title isActive={props.isActive}>{props.title}</Title>
      {cover}
    </Container>
  );

  function onClick() {
    props.onClick(props.eventId);
  }
}

ManageEventsSidebarItem.propTypes = {
  eventId: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isLast: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  posterUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
};

ManageEventsSidebarItem.defaultProps = {
  isActive: false,
  isLast: false,
  posterUrl: '',
};

export default ManageEventsSidebarItem;



// WEBPACK FOOTER //
// ./src/views/ManageEvents/ManageEventsSidebar/ManageEventsSidebarItem/ManageEventsSidebarItem.js